import React, { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import api from '../services/api';
import { Truck, UserPlus } from 'lucide-react';
import toast from 'react-hot-toast';

export default function Register() {
  const [form, setForm] = useState({ name:'', email:'', password:'', confirmPassword:'', phone:'' });
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (form.password !== form.confirmPassword) return toast.error('Passwords do not match');
    if (form.password.length < 6) return toast.error('Password must be at least 6 characters');
    setLoading(true);
    try {
      const { data } = await api.post('/auth/register', {
        name: form.name, email: form.email, password: form.password, phone: form.phone
      });
      if (data.success) {
        localStorage.setItem('token', data.token);
        localStorage.setItem('user', JSON.stringify(data.user));
        toast.success(data.message || 'Registered successfully');
        setTimeout(() => nav('/'), 800);
      } else {
        toast.error(data.message || 'Registration failed');
      }
    } catch (err) {
      toast.error(err?.response?.data?.message || 'Registration failed');
    } finally { setLoading(false); }
  };

  return (
    <div className="login-wrap">
      <form className="login-box" onSubmit={submit}>
        <div style={{textAlign:'center',marginBottom:18}}>
          <div style={{width:60,height:60,background:'#059669',borderRadius:12,display:'inline-flex',alignItems:'center',justifyContent:'center',color:'#fff'}}>
            <UserPlus size={30}/>
          </div>
        </div>
        <h1 style={{color:'#059669'}}>Create Admin Account</h1>
        <p className="subtitle">Register your organization. Staff accounts can be added later from the Users page.</p>

        <div className="form-group">
          <label>Full Name *</label>
          <input value={form.name} onChange={e=>setForm({...form, name:e.target.value})} required autoFocus />
        </div>
        <div className="form-group">
          <label>Email Address *</label>
          <input type="email" value={form.email} onChange={e=>setForm({...form, email:e.target.value})} required />
        </div>
        <div className="form-group">
          <label>Phone (optional)</label>
          <input type="tel" value={form.phone} onChange={e=>setForm({...form, phone:e.target.value})} />
        </div>
        <div className="form-group">
          <label>Password * (min 6 chars)</label>
          <input type="password" value={form.password} onChange={e=>setForm({...form, password:e.target.value})} required minLength={6} />
        </div>
        <div className="form-group">
          <label>Confirm Password *</label>
          <input type="password" value={form.confirmPassword} onChange={e=>setForm({...form, confirmPassword:e.target.value})} required />
        </div>

        <button type="submit" className="btn-primary" style={{background:'#059669'}} disabled={loading}>
          {loading ? 'Creating account...' : 'Create Account'}
        </button>

        <p style={{textAlign:'center',marginTop:18,fontSize:12.5,color:'#64748b'}}>
          Already have an account? <Link to="/login" style={{color:'#1e40af',fontWeight:600,textDecoration:'none'}}>Sign in</Link>
        </p>
        <p style={{textAlign:'center',marginTop:12,fontSize:11,color:'#94a3b8'}}>© 2026 Noris Solutions</p>
      </form>
    </div>
  );
}
